import { Box } from "@stenajs-webui/core";
import { FlatButton, stenaInfoCircle } from "@stenajs-webui/elements";
import { Popover } from "@stenajs-webui/tooltip";
import { InfoBoxItem } from "../InfoBoxItem";
import { RouteAgreementBox } from "../types";
import { useSelector } from "react-redux";
import { StoreState } from "@/redux/RootReducer";
import { formatDateStringWithLocalTimeZone } from "@/lib/dates/formatters";
import { IndentValues } from "@/lib/utils/IndentValues";
import { ZIndex } from "@/lib/utils/ZIndexEnum";

interface Props {
  routeAgreement: RouteAgreementBox;
}

const selector = (state: StoreState) =>
  state.routeAgreementDetails.workspace.routes.currencyId;

export const RouteAgreementInfoPairPopover: React.FC<Props> = ({
  routeAgreement,
}) => {
  const currencyId = useSelector(selector);
  return (
    <Popover
      zIndex={ZIndex.high}
      placement={"right"}
      disablePadding
      trigger={"click"}
      renderTrigger={(props) => (
        <Box width={16}>
          <FlatButton leftIcon={stenaInfoCircle} {...props} />
        </Box>
      )}
      appendTo={document.body}
    >
      <Box indent={IndentValues.SIXTEEN} spacing>
        <InfoBoxItem
          leftContent={"Name"}
          rightContent={routeAgreement.name}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Agr. cur."}
          rightContent={(currencyId && routeAgreement.currency.code) ?? ""}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Invoice curr."}
          rightContent={currencyId ?? routeAgreement.currency.code}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"No."}
          rightContent={routeAgreement.agreementNumber}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Created"}
          rightContent={
            formatDateStringWithLocalTimeZone({
              dateString: routeAgreement.writeHistory?.createdAt?.isoString,
              options: {
                dateStyle: "short",
                timeStyle: "short",
              },
            }) ?? ""
          }
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Created by"}
          rightContent={routeAgreement.writeHistory?.createdBy?.name || ""}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Modified"}
          rightContent={
            (routeAgreement.writeHistory?.modifiedAt?.isoString &&
              formatDateStringWithLocalTimeZone({
                dateString: routeAgreement.writeHistory?.modifiedAt?.isoString,
                options: {
                  dateStyle: "short",
                  timeStyle: "short",
                },
              })) ??
            ""
          }
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Modified by"}
          rightContent={routeAgreement.writeHistory?.modifiedBy?.name || ""}
          popoverEnabled
        />
      </Box>
    </Popover>
  );
};
